import { Link } from "react-router-dom";

/**
 * The splitter: the site is half shirt store, half app, and this is where a visitor says which.
 *
 * The two tiles are shaped like app icons on purpose — the same square the brand already lives in
 * on a phone home screen.
 */
export function Home() {
  return (
    <div className="splitter">
      <h1 className="wordmark big">Gymquisition</h1>
      <nav className="tiles">
        <Link className="tile" to="/store">
          <img src="/tile-store.png" alt="" />
          <span>Store</span>
        </Link>
        <Link className="tile" to="/app">
          <img src="/tile-app.png" alt="" />
          <span>App</span>
        </Link>
      </nav>
    </div>
  );
}
